module.exports = __webpack_public_path__ + "static/img/li1_12.e305977e.png";